module.exports = {
    APP_NAME: 'Tuskey',
    APP_NAVBAR_BG: 'warning',
    API_URL: 'https://www.tuskey.one/api/v1',
    ECL_URL: 'https://ecl.tuskey.one/cardtypeselect',
    VUEX_KEY: 'WWW.TUSKEY.VUEX',
    GOOGLE_ANALYTICS: 'G-77C47GXFBB',
}

